<template>
<div class="x_box">
    <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/purchase/invoices">{{ $t('purchase_invoice') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">[{{ invoice.Num }}]</li>
        </ol>
    <div class="x_header">
        <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
        <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onPrint"><i class="fa fa-print"></i> {{$t('print')}}</button>
        <template v-if="invoice.Status=='Draft'">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onEdit"><i class="fa fa-pencil"></i> {{$t('edit')}}</button>
            <!-- <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onApproval"><i class="fa fa-check"></i> {{ $t('approval') }}</button>
            <button type="button" class="btn btn-outline-danger btn-sm no-bor" @click="confirmDelete"><i class="fa fa-times"></i> {{ $t('delete') }}</button> -->
        </template>
        <template v-else>
            <router-link v-if="invoice.Balance>0" :to="{ name: 'purchase_receipt_create', params: { id: $route.params.id }}" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-money"></i> {{$t('purchase_receipt')}}</router-link>
        </template>
    </div>
    <div class="x_body">
        <div class="card f_card">
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-6">
                        <table class="table-print">
                            <tbody>
                                <tr>
                                    <td style="width: 100px;">{{ $t('vendor') }}</td>
                                    <td style="width: 15px;">:</td>
                                    <td>{{invoice.VendorName}}</td>
                                </tr>
                                <tr>
                                    <td style="width: 100px;">{{ $t('contact') }}</td>
                                    <td style="width: 15px;">:</td>
                                    <td>{{invoice.Contact}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-sm-6">
                        <table class="table-print" align="right">
                            <tbody>
                                <tr>
                                    <td style="width: 100px;">{{$t('invoice_no')}}</td>
                                    <td style="width: 15px;">:</td>
                                    <td>{{invoice.Num}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('date')}}</td>
                                    <td>:</td>
                                    <td>{{$format(invoice.Date, 'DD/MM/YYYY')}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('due_date')}}</td>
                                    <td>:</td>
                                    <td>{{$format(invoice.DueDate, 'DD/MM/YYYY')}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <table class="table table-bordered table-sm no-bor">
                            <thead>
                                <tr>
                                    <th class="text-center" style="width: 50px;">{{$t('no')}}</th>
                                    <th>{{$t('code')}}</th>
                                    <th>{{$t('item_name')}}</th>
                                    <th class="text-center" style="width: 100px;">{{$t('qty')}}</th>
                                    <th class="text-center" style="width: 100px;">{{$t('uom')}}</th>
                                    <th class="text-right" style="width: 100px;">{{$t('cost')}}</th>
                                    <th class="text-right" style="width: 100px;">{{$t('tax_line')}}(%)</th>
                                    <th class="text-right" style="width: 100px;">{{$t('sub_total')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(ret,index) in lines" :key="ret.Id">
                                    <td class="text-center">{{index+1}}</td>
                                    <td>{{ret.ItemCode}}</td>
                                    <td>{{ret.ItemName}}</td>
                                    <td class="text-center">{{ret.Quantity}}</td>
                                    <td class="text-center">{{ret.UomName}}</td>
                                    <td class="text-right">{{$dollar(ret.Price)}}</td>
                                    <td class="text-right">{{ret.TaxLine}}</td>
                                    <td class="text-right">{{$dollar(ret.SubTotal)}}</td>
                                </tr>
                                <tr>
                                    <td colspan="7" class="text-right">{{$t('total')}}:</td>
                                    <td class="text-right">{{$dollar(invoice.GrandTotal)}}</td>
                                </tr>
                                <tr>
                                    <td colspan="7" class="text-right">{{$t('taxes')}}:</td>
                                    <td class="text-right">{{$dollar(invoice.TaxVat)}}</td>
                                </tr>
                                <tr>
                                    <td colspan="7" class="text-right">{{$t('grand_total')}}:</td>
                                    <td class="text-right">{{$dollar(invoice.PaidAmount)}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row" v-if="invoice.Status=='Posted'">
                    <div class="col-sm-12">
                        <br>
                        <p class="blue"><i class="fa fa-car" aria-hidden="true"></i> {{$t('stock_in')}}</p>
                        <table class="table table-bordered table-striped table-sm no-bor">
                            <thead>
                                <tr>
                                    <th style="width: 50px;" class="text-center">{{ $t('no') }}</th>
                                    <th>{{ $t('stock_in_no') }}</th>
                                    <th>{{ $t('date') }}</th>
                                    <th>{{ $t('type') }}</th>
                                    <th>{{ $t('ref_num') }}</th>
                                    <th>{{$t('branch_name')}}</th>
                                    <th>{{$t('receiver') }}</th>
                                    <th style="width: 80px;">{{$t('status')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(ret, index) in stockins" :key="index">
                                    <td class="text-center">{{ index+1 }}</td>
                                    <td><router-link :to="{ name: 'stock_in_preview', params: { id: ret.Id }}">{{ ret.Num }}</router-link></td>
                                    <td>{{ $format(ret.InDateAt, 'DD-MM-YYYY') }}</td>
                                    <td>{{ret.DocSource}}</td>
                                    <td>{{ret.DocSourceNo}}</td>
                                    <td>{{ ret.BranchName }}</td>
                                    <td>{{ ret.EmployeeName }}</td>
                                    <td class="cell-badge" v-html="$statusLabel(ret.Status)"></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <br>
                <div class="row" v-if="invoice.Status=='Posted'">
                    <div class="col-sm-12">
                        <p class="blue"><i class="fa fa-dollar" aria-hidden="true"></i> {{$t('purchase_receipt')}}</p>
                        <table class="table table-bordered table-sm table-striped no-bor">
                            <thead>
                                <tr>
                                    <th style="width: 50px;" class="text-center">{{$t('no')}}</th>
                                    <th>{{ $t('code') }}</th>
                                    <th>{{ $t('date') }}</th>
                                    <th>{{ $t('vendor') }}</th>
                                    <th>{{ $t('ref_num') }}</th>
                                    <th>{{ $t('payment_menthod') }}</th>
                                    <th>{{ $t('description') }}</th>
                                    <th class="sorting">{{ $t('amount') }}</th>
                                    <th class="sorting" style="width: 80px;">{{ $t('status') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(ret, index) in receipts" :key="index">
                                    <td class="text-center">{{index+1}}</td>
                                    <td>
                                        <router-link :to="{ name: 'purchase_receipt_preview', params:{ id:ret.Id }}">{{ret.Num}}</router-link>
                                    </td>
                                    <td>{{$format(ret.Date, 'DD/MM/YYYY')}}</td>
                                    <td>{{ret.VendorName}}</td>
                                    <td>{{ret.DocSourceNo}}</td>
                                    <td>{{ret.AccountName}}</td>
                                    <td>{{ret.Description}}</td>
                                    <td class="text-right">{{$money(ret.PaidAmount)}}</td>
                                    <td class="cell-badge" v-html="$statusLabel(ret.Status)"></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
    import Swal from 'sweetalert2';
    export default {
        data: function(){
            return {
                invoice: {
                    Status: '',
                    Balance: 0,
                    DocSource: ''
                },
                isCompleteStock: true,
                lines: [],
                stockins: [],
                receipts: []
            }
        },
        created: function(){
            let id = this.$route.params.id;
            if(id != undefined && id != null && id != ''){
                let loading = this.$loading.show();
                var req = {
                    Id: id,
                    IsIncludeStockin: true,
                    IsIncludeReceipt: true
                };
                this.$api().post('po/invoice/find', req).then(res => {
                    var data = res.data.Data;
                    this.invoice = data.POInvoice;
                    this.lines = data.POInvoiceLines;
                    this.stockins = res.data.Json.Stockins;
                    this.receipts = res.data.Json.Receipts;
                    this.calculate();
                }).finally(function(){ loading.hide(); });
            }
        },
        methods: {
            onApproval(){
                let id = this.$route.params.id;
                let loading = this.$loading.show();
                this.$api().post('po/invoice/approval', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        this.$router.go(-1);
                    }
                }).finally(function(){ loading.hide(); });
            },
            calculate(){
                let totalQty = 0;
                let totalStockIn = 0;
                this.lines.forEach(element => {
                    totalQty += Number(element.Quantity);
                    totalStockIn += Number(element.StockInQty);
                });
                this.isCompleteStock = (totalQty - totalStockIn) > 0;
            },
            confirmDelete(){
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                    }).then((result) => {
                    if (result.value) {
                        this.deleteById();
                    }
                });
            },
            deleteById(){
                let id = this.$route.params.id;
                let loading = this.$loading.show();
                this.$api().post('po/invoice/cancel', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        this.$router.go(-1);
                    }
                }).finally(function(){ loading.hide(); });
            },
            onEdit(){
                let routeName = 'po_invoice_update';
                if(this.invoice.DocSource == 'Delivery') routeName = 'purchase_invoice_update';
                this.$router.push({ name: routeName, params: { id: this.$route.params.id }});
            },
            onPrint(){
                let link = '/print/purchase/' + this.$route.params.id;
                window.open(link, '_blank');
            }
        }
    }
</script>
<style scoped>
    label{
        margin-bottom: 0;
    }
    .none-left{
        border-left: none;
    }
    .none-bottom{
        border-bottom: none;
        border-top: none;
    }
</style>